
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1240 260","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"app-inline-svg",attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M823 20h404v225H823zM12 20h438v32H12zM12 71h765v17H12zM12 98h743v17H12zM12 125h664v17H12zM12 152h55v32H12zM76 152h77v32H76zM162 152h98v32h-98zM12 220h64v17H12zM99 220h127v17H99zM249 220h55v17h-55z"}})])])
          )
        }
      }
    